import { IAppState } from '../../types/redux';

export function selectIsRedesignedMainPage(state: IAppState) {
  return state.isRedesignedMainPage;
}
